import React from 'react';
import { useSelector } from 'react-redux';
import Card from '../../elements/Card';
import LoadingBars from '../../elements/LoadingBars';
import styles from './styles.scoped.css';
import { thousand } from '../../../utils/format';
import ButtonLink from '../../elements/ButtonLink';

export default function CardSummary() {
  const {
    dataSummary: {
      totalOutlet = 0,
      totalOutletOperate = 0,
      totalOutletTransaction = 0,
      totalOutletProduct = 0,
    },
    isLoadingSummary,
  } = useSelector((s) => s.home);

  const summaries = [
    { label: 'Jumlah Transaksi Pangkalan', value: totalOutletTransaction, unit: '', image: 'assets/illu-shipment.svg' },
    { label: 'Jumlah LPG Terjual', value: totalOutlet, unit: 'Tabung', image: 'assets/illu-lpg.svg' },
    { label: 'Total Pangkalan', value: totalOutletOperate, unit: 'Pangkalan', image: 'assets/illu-shipment.svg' },
    {
      label: 'Pangkalan dengan Produk Kritis',
      value: totalOutletProduct,
      unit: 'Pangkalan',
      to: '/outlet?is_critical=1',
      image: 'assets/illu-shipment.svg'
    },
  ];

  return (
    // <div className={styles.root}>
    //   {summaries.map((sm, index) => (
    //     <Card className={styles['card-summary']} key={index}>
    //       <div>
    //         <h5>{sm.label}</h5>
    //         {isLoadingSummary ? (
    //           <LoadingBars className={styles['loading-bars']} size={3} />
    //         ) : (
    //           <div>
    //             <h2>{thousand(sm.value)}</h2>
    //             {sm.to && (
    //               <ButtonLink to={sm.to}>
    //                 <img src="/assets/ic-chevron-right.svg" />
    //               </ButtonLink>
    //             )}
    //           </div>
    //         )}
    //       </div>
    //     </Card>
    //   ))}
    // </div>
    <div className={styles.root}>
      {summaries.map((sm, index) => (
        <Card className={styles['card-summary']} key={index}>
          <div>
            <h5>{sm.label}</h5>
            {isLoadingSummary ? (
              <LoadingBars className={styles['loading-bars']} size={3} />
            ) : (
              <div>
                <h2>{thousand(sm.value)} {sm.unit}</h2>
                {sm.to && (
                  <ButtonLink outlined={true} to={sm.to}>
                    Detail
                  </ButtonLink>
                )}
              </div>
            )}
          </div>
          <div>
            <img alt="revenue" src={sm.image} />
          </div>
        </Card>
      ))}
    </div>
  );
}
